import JWPlayer from "@jwplayer/jwplayer-react";
import React, { useEffect, useRef, useState } from "react";

import Image from "../image";
import { Script } from "gatsby";

export default function HeaderVideoPlayer({
  jwplayerID,
  heroImg,
  heroGatsbyImage
}) {
  // const [loadHeaderVid, setHeaderVid] = useState("");
  // useEffect(() => {
  //   setHeaderVid(
  //     <JWPlayer
  //       playlist={`https://cdn.jwplayer.com/v2/media/${jwplayerID}`}
  //       playerId="jw-player"
  //       library="https://content.jwplatform.com/libraries/d47BMX5V.js"
  //       image={heroImg}
  //       onTime={(event) => {
  //         if (event.position >= event.duration - 0.3) {
  //           window.jwplayer().seek(0.1);
  //         }
  //       }}
  //       onViewable={(item) => {
  //         if (item.viewable) {
  //           window.jwplayer().play();
  //         } else {
  //           window.jwplayer().pause();
  //         }
  //       }}
  //       // isMuted={true}
  //       aspectRatio={"16:9"}
  //       autostart={true}
  //       controls={true}
  //       repeat={true}
  //       displaytitle={false}
  //       displaydescription={false}
  //       displayheading={false}
  //       stretching={"fill"}
  //       width={"100%"}
  //       height={"100%"}
  //     />
  //   );
  // }, [jwplayerID]);

  return (
    <>
      {jwplayerID && (
        <div
          className="jw-video-container bg-cover bg-center relative"
          data-mediaid={`${jwplayerID}`}
        >
          <Image
            image={heroGatsbyImage}
            sourceUrl={heroImg}
            loading={"eager"}
            imageClass={
              "z-0 absolute top-0 bottom-0 left-0 top-0 object-cover w-full"
            }
            extraProps={{ loading: "eager" }}
          />
          {/* {loadHeaderVid} */}
        </div>
      )}
    </>
  );
}
